import React from 'react';
import Container from '../../../components/Container';
import Input from '../../../components/Form/Input';
import useForm from '../../../hooks/useForm';
import { UserContext } from '../../../UserContext';
import { Form, DsFlex, Grid, Submit, RecentSearches, CenterVert } from './styled';
import { default as StyledButton } from '../../../components/Button';
import { api } from '../../../services/api';
import {
    Button,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation, useNavigate } from 'react-router';
import { Center } from '../../NotAfound/styled';
import { IoMdImages } from 'react-icons/io';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import { Hr } from '../../Register/styled';
import { Header } from '../Show/styled';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { Pagination } from '@material-ui/lab';
import Cookies from 'universal-cookie';
import { Catalogs, Linhas, RepositoriesProps } from '../../../interfaces';
import Alert from '../../../components/Alert';
import Select from '../../../components/Form/Select';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
    },
    media: {
        height: 140,
    },
    alert: {
        marginBottom: 20
    }
});

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Search: React.FC = () => {
    document.title = "Repositório - Sultan Veste a Casa";

    const classes = useStyles();

    const navigate = useNavigate();

    const numero = useForm();
    const { onChange: changeNumero, ...numeroForm } = numero;

    const codigo = useForm();
    const { onChange: changeCodigo, ...codigoForm } = codigo;

    const descricao = useForm();
    const { onChange: changeDescricao, ...descricaoForm } = descricao;

    const catalogo = useForm();
    const { onChange: changeCatalogo, ...catalogoForm } = descricao;

    const linhas = useForm();
    const { onChange: changeLinha, ...linhasForm } = descricao;

    const [error, setError] = React.useState('');
    const [repositories, setRepositories] = React.useState<RepositoriesProps[] | null>();
    const [catalogs, setCatalogs] = React.useState<Catalogs[]>();
    const [lines, setLinhas] = React.useState<Linhas[] | []>([]);
    const [page, setPage] = React.useState(1);
    const [count, setCount] = React.useState(1);

    const { loading, setLoading } = React.useContext(UserContext);
    const params = useQuery();

    const cookies = new Cookies();
    const searches = cookies.get('searches');

    const RepositoriosPorPagina = 20;

    React.useEffect(() => {
        if (params.get('codigo')) codigo.setValue(`${params.get('codigo')}`);
        if (params.get('descricao')) descricao.setValue(`${params.get('descricao')}`);
        if (params.get('numero')) numero.setValue(`${params.get('numero')}`);

        if (params.get('codigo') || params.get('descricao') || params.get('numero')) {
            doSearchParams(params.get('codigo'), params.get('descricao'), params.get('numero'));
        }

        getCatalog();
        // eslint-disable-next-line
    }, []);

    const getCatalog = async () => {
        try {
            setLoading(true);

            const { data } = await api.get('/catalog');

            setCatalogs(data.catalogs);
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        } finally {
            setLoading(false);
        }
    }

    async function doSearchParams(codigo: string | null, descricao: string | null, numero: string | null) {
        try {
            setLoading(true);

            const { data } = await api.post('/repositories', {
                pk: numero,
                code: codigo,
                description: descricao,
                page: page - 1,
                qpp: RepositoriosPorPagina,
            });

            // Redireciona o usuário para o repositório caso ele acerte o Código ou PK
            if (data.repositories.length > 0 && (numero === data.repositories[0].PKRepositorio || codigo === data.repositories[0].sCodigo.toString().trim())) {
                navigate(`${process.env.PUBLIC_URL}/usuario/repositorio/${data.repositories[0].PKRepositorio}`);
            }

            window.history.pushState(`Pesquisa Repositorio`, `Pesquisa Repositorio`, `/area-restrita/usuario/repositorio?descricao=${descricao}&codigo=${codigo}&numero=${numero}`);
            setRepositories(data.repositories);
            setCount(data.count);


        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        } finally {
            setLoading(false);
        }
    }

    async function doSearch(e?: React.FormEvent) {
        if (e) e.preventDefault();
        getRepositories(1);
    }

    const handleMessageError = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setError('');
    };

    const viewRepository = (pk: number) => {
        navigate(`${process.env.PUBLIC_URL}/usuario/repositorio/${pk}`);
    }

    const getLinha = async (pk: string) => {
        try {
            setLoading(true);

            const { data } = await api.get(`/linhas/${pk}`);

            setLinhas(data.linhas);
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        } finally {
            setLoading(false);
        }
    }

    const getRepositories = async (pagination: number) => {
        try {
            setLoading(true);

            if (codigo.value !== '' || numero.value !== '' || descricao.value !== '') {
                const { data } = await api.post('/repositories', {
                    pk: numero.value,
                    code: codigo.value,
                    description: descricao.value,
                    page: pagination - 1,
                    qpp: RepositoriosPorPagina,
                });
                // Redireciona o usuário para o repositório caso ele acerte o Código ou PK
                // data.map((item: any) => {
                //     // item.PKRepositorio
                //     console.log(item);

                // })
                // console.log('passou', codigo.value)
                // console.log('aqui esta o data', data)
                // const arr = []
                // for (var item of data.repositories) {
                //     arr.push(item.PKRepositorio)
                // }
                // var unique = arr.filter((v, i, a) => a.indexOf(v) === i);
                // console.log('aqui eh unique',unique);
                
                // window.history.pushState(`pesquisa`, `pesquisa`, `/area-restrita/usuario/repositorios?ids=${data.repositories[0].PKRepositorio}`)
                // if (data.repositories.length > 0) {
                if (data.repositories.length > 0 && (numero.value === data.repositories[0].PKRepositorio || codigo.value === data.repositories[0].sCodigo.toString().trim())) {
                    navigate(`${process.env.PUBLIC_URL}/usuario/repositorio/${data.repositories[0].PKRepositorio}`);
                    // navigate(`${process.env.PUBLIC_URL}/usuario/repositorios/${unique.toString()}`);
                } else {
                    console.log('passou aqui 2')
                    window.history.pushState(`Pesquisa`, `Pesquisa`, `/area-restrita/usuario/repositorio?descricao=${descricao.value}&codigo=${codigo.value}&numero=${numero.value}`);
                    setRepositories(data.repositories);
                    setCount(data.count);
                }
            } else if (catalogo.value !== '' || linhas.value !== '') {
                const { data } = await api.get(`/repository/line/${linhas.value}`);
                console.log('passou')
                navigate(`${process.env.PUBLIC_URL}/usuario/repositorio/${data.iRepositorio}`);
            }
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        } finally {
            setLoading(false);

        }
    }


    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        getRepositories(value);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleBack = () => {
        setRepositories(null);
        navigate(`${process.env.PUBLIC_URL}/usuario/repositorio/`);
    }

    const handleChangeCatalog = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setLinhas([]);

        if (!event.target.value) return;

        catalogo.setValue(event.target.value);
        getLinha(event.target.value);

        codigo.setValue('');
        numero.setValue('');
        descricao.setValue('');
    }

    const handleChangeLine = (event: React.ChangeEvent<HTMLSelectElement>) => {
        linhas.setValue(event.target.value);

        codigo.setValue('');
        numero.setValue('');
        descricao.setValue('');
    }

    const handleChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        codigo.setValue(event.target.value);

        numero.setValue('');
        descricao.setValue('');
        catalogo.setValue('');
        linhas.setValue('');
        setLinhas([]);
    }

    const handleChangeNumero = (event: React.ChangeEvent<HTMLInputElement>) => {
        numero.setValue(event.target.value);

        codigo.setValue('');
        descricao.setValue('');
        catalogo.setValue('');
        linhas.setValue('');
        setLinhas([]);
    }

    const handleChangeDescricao = (event: React.ChangeEvent<HTMLInputElement>) => {
        descricao.setValue(event.target.value);

        codigo.setValue('');
        numero.setValue('');
        catalogo.setValue('');
        linhas.setValue('');
        setLinhas([]);
    }

    return (
        <Container>
            {!repositories ?
                <CenterVert>
                    <Form className="shadow" onSubmit={doSearch}>
                        <DsFlex>
                            <Input
                                label="Numero do Repositório"
                                placeholder="Exemplo: 865"
                                id="numero"
                                type="number"
                                {...numeroForm}
                                onChange={handleChangeNumero}
                            />
                            <Input
                                label="Código do Produto"
                                placeholder="Exemplo: 316414"
                                id="codigo"
                                type="number"
                                {...codigoForm}
                                onChange={handleChangeCode}
                            />
                        </DsFlex>
                        <Input
                            label="Descrição do Produto"
                            placeholder="Exemplo: Tapete Estampado"
                            id="descricao"
                            type="text"
                            {...descricaoForm}
                            onChange={handleChangeDescricao}
                        />
                        {catalogs &&
                            <DsFlex>
                                <div>
                                    <Select
                                        label="Catalogo"
                                        {...catalogoForm}
                                        value={catalogo.value}
                                        onChange={handleChangeCatalog}
                                        options={catalogs.map((el: Catalogs) => {
                                            return {
                                                id: el.PK,
                                                description: el.sNome
                                            }
                                        })}
                                    />
                                </div>

                                <div>
                                    {lines.length > 0 ?
                                        <Select
                                            label="Linhas"
                                            {...linhasForm}
                                            value={linhas.value}
                                            onChange={handleChangeLine}
                                            required={catalogo.value !== ''}
                                            options={lines.map((el: Linhas) => {
                                                return {
                                                    id: el.PKFolha,
                                                    description: el.sDirecaoHierarquia
                                                }
                                            })}
                                        />
                                        :
                                        <Select
                                            label="Linhas"
                                            {...linhas}
                                            disabled
                                            options={[]}
                                        />
                                    }
                                </div>
                            </DsFlex>
                        }
                        <Submit>
                            {loading ? <StyledButton type="submit" disabled>Carregando...</StyledButton> :
                                <StyledButton type="submit">Pesquisar</StyledButton>}
                        </Submit>
                        {searches &&
                            <RecentSearches>
                                <Hr />
                                <h3>REPOSITÓRIOS RECENTES</h3>
                                <ul>
                                    {searches.split('|').slice(0, 5).reverse().map((item: string, index: number) => (
                                        <div key={index} onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/repositorio/${item}`)} className="ds-flex align-items-center">
                                            <QueryBuilderIcon />
                                            <li>{item}</li>
                                        </div>
                                    ))}
                                </ul>
                            </RecentSearches>
                        }

                    </Form>
                    <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error} />
                </CenterVert>
                :
                <>
                    {repositories.length > 0 &&
                        <>
                            <Header className="ds-flex space-between align-items-center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    startIcon={<KeyboardBackspaceIcon />}
                                    onClick={handleBack}
                                >
                                    VOLTAR
                                </Button>
                                <p className="bold">Repositórios baseados em sua pesquisa</p>
                            </Header>
                            <div className={classes.root}>
                                <Pagination count={Math.ceil(count / RepositoriosPorPagina)} size="large" page={page} onChange={handleChange} />
                            </div>
                            <Grid>
                                {
                                    repositories.map((el, index) => (
                                        <Card key={index} className={classes.root}>
                                            <CardActionArea onClick={() => viewRepository(el.PKRepositorio)}>
                                                <CardMedia
                                                    className={classes.media}
                                                    image={el.average_image_url}
                                                    title={el.sCodigo + ' ' + el.sDescricaoRepositorio}
                                                />
                                                <CardContent>
                                                    <Typography gutterBottom variant="h5" component="h2">
                                                        {el.PKRepositorio + ' - ' + el.sDescricaoRepositorio}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary" component="p">
                                                        {el.sDescricao} - Situação: {el.sDescSituacao}
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    ))
                                }
                            </Grid>
                            <div className={classes.root}>
                                <Pagination count={Math.ceil(count / RepositoriosPorPagina)} size="large" page={page} onChange={handleChange} />
                            </div>
                        </>
                    }
                    {repositories.length === 0 &&
                        <Center className="centro">
                            <IoMdImages size={70} />
                            <h1>Sem Resultados!</h1>
                            <p>Não foi encontrado nenhum repositório! <span className="link-default bold" onClick={() => setRepositories(null)}>Clique Aqui</span> para <strong>Pesquisar</strong> novamente.</p>
                        </Center>
                    }
                </>
            }
        </Container>
    )
}

export default Search;
